import axios from "axios"
import { useMemo, useState } from "react"

const createApiInstance = (apiUrl, setLogOutTrigger, logOutTrigger) => {
    const instance = axios.create({
        baseURL: apiUrl,
    })

    instance.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("token")
            if (token) {
                config.headers.Authorization = `Bearer ${token}`
            }
            return config;
        },
        (error) => Promise.reject(error)
    )

    // Interceptor dla odpowiedzi – ponawia zapytanie przy 404, ale nie przy 500 i 401
    instance.interceptors.response.use(
        (response) => response,
        async (error) => {
            const originalRequest = error.config
            if (!originalRequest) return Promise.reject(error)

            const { status } = error.response || {}

            // Jeśli błąd to 404 i request nie został jeszcze ponowiony (_retry nie ustawione)
            if (status === 404 && !originalRequest._retry) {
                originalRequest._retry = true
                return instance(originalRequest)
            }
            if (status === 401) {
                if (logOutTrigger === null) {
                    setLogOutTrigger(true)
                }
                else {
                    setLogOutTrigger(prev => !prev)
                }
                return Promise.reject(error)
            }
            // Dla błędów 500 (Internal Server Error)
            if (status === 500) {
                return Promise.reject(error)
            }
            return Promise.reject(error)
        }
    )
    return instance
}

// const useApi = (apiUrl) => {
//     const [logOutTrigger, setLogOutTrigger] = useState(null)

//     const api = useMemo(() => {
//         if (!apiUrl) return null
//         return createApiInstance(apiUrl, setLogOutTrigger, logOutTrigger)
//     }, [apiUrl])

//     return { api, logOutTrigger }
// }

const useApi = (apiUrl) => {
    const [logOutTrigger, setLogOutTrigger] = useState(null)

    const api = useMemo(() => {
        if (!apiUrl) {
            return null
        }
        return createApiInstance(apiUrl, setLogOutTrigger)
    }, [apiUrl, setLogOutTrigger])

    return { api, logOutTrigger }
}

export default useApi




